import type { Store } from "../../../client/stores";
import type { SessionState } from "./auth/backends";
import { md5 } from "./md5";

declare global {
    interface Window {
        ats?: {
            start: (props: {
                placementID: number;
                storageType: string;
                logging: string;
                emailHashes: string[];
            }) => void;
        };
    }
}

const sendUserInfo = (email = "") => {
    if (email) {
        email = email.trim().toLowerCase();
        window.ats?.start({
            placementID: 2102,
            storageType: "localStorage",
            logging: "error",
            emailHashes: [md5(email)],
        });
    }
};

let atsScriptSetup = false;
export const setupLiveRamp = (store: Store) => {
    const initLiveRamp = (status?: SessionState) => {
        if (status?.authenticated) {
            if (!atsScriptSetup) {
                const atsScript = document.createElement("script");
                atsScript.onload = () => sendUserInfo(store.session.currentSession?.state.profile?.email);
                atsScript.src = "https://ats.rlcdn.com/ats.js";
                document.body.appendChild(atsScript);
                atsScriptSetup = true;
            } else {
                sendUserInfo(store.session.currentSession?.state.profile?.email);
            }
        }
    };
    initLiveRamp(store.session.currentSession?.state);
    store.session.currentSession?.onStatusChanged.sub(initLiveRamp);
};
